var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 5.114 2.286.4.4 2.286 5.114 7 .4 11.714 2.286 13.6 7 8.886l4.714 4.714 1.886-1.886L8.886 7 13.6 2.286 11.714.4z"
})));
export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "static/media/close.cf00a2de.svg";